import { useState } from "react";
import { Loader2, Pin, Send } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { apiErrorMessage } from "@/lib/api";

export default function ChatComposer({ onSend, canMarkImportant }) {
  const [text, setText] = useState("");
  const [important, setImportant] = useState(false);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState("");

  const submit = async () => {
    const t = text.trim();
    if (!t || sending) return;
    setSending(true); setError("");
    try {
      await onSend(t, important);
      setText(""); setImportant(false);
    } catch (e) { setError(apiErrorMessage(e)); } finally { setSending(false); }
  };

  return (
    <div className="border-t border-border bg-white p-3">
      {error && <div className="mb-2 rounded-lg border border-danger/25 bg-danger/10 px-3 py-1.5 text-xs text-danger" data-testid="chat-error">{error}</div>}
      <div className="flex items-end gap-2">
        <Textarea value={text} onChange={(e) => setText(e.target.value)} rows={2} placeholder="Scrivi un messaggio…"
          onKeyDown={(e) => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); submit(); } }}
          className={`min-h-[44px] resize-none ${important ? "border-danger ring-1 ring-danger/40" : ""}`} data-testid="chat-input" />
        <div className="flex flex-col gap-1.5">
          {canMarkImportant && (
            <Button type="button" size="sm" variant={important ? "destructive" : "outline"} onClick={() => setImportant((v) => !v)}
              className="gap-1" title="Marca come IMPORTANTE" data-testid="chat-important-toggle" aria-pressed={important}>
              <Pin className="h-3.5 w-3.5" /> <span className="hidden sm:inline">Importante</span>
            </Button>
          )}
          <Button type="button" size="sm" onClick={submit} disabled={sending || !text.trim()} className="gap-1" data-testid="chat-send">
            {sending ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Send className="h-3.5 w-3.5" />} Invia
          </Button>
        </div>
      </div>
      <div className="mt-1 text-[11px] text-slate-400">Invio con Invio · a capo con Maiusc+Invio</div>
    </div>
  );
}
